module.exports = __webpack_public_path__ + "img/rank_10.f84b446.png";